module.exports = __webpack_public_path__ + "static/img/startqrcode.0f8da894.png";